var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttentionWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0717 7.27273L12.8757 13.3281H11.1243L10.9283 7.27273H13.0717ZM11.9979 16.1236C11.6939 16.1236 11.4325 16.0156 11.2138 15.7997C10.9979 15.5838 10.8899 15.3224 10.8899 15.0156C10.8899 14.7145 10.9979 14.4574 11.2138 14.2443C11.4325 14.0284 11.6939 13.9205 11.9979 13.9205C12.2905 13.9205 12.5476 14.0284 12.7692 14.2443C12.9936 14.4574 13.1058 14.7145 13.1058 15.0156C13.1058 15.2202 13.0533 15.4062 12.9482 15.5739C12.8459 15.7415 12.7109 15.875 12.5433 15.9744C12.3786 16.0739 12.1967 16.1236 11.9979 16.1236Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionWhite);
export default __webpack_public_path__ + "static/media/attention-white.4fd4f4130f4c72e0982b4fe84bd66e02.svg";
export { ForwardRef as ReactComponent };